import getRolesDefinition from '../../../roles';

class LoginController {
  /* @ngInject */
  constructor(
    $window,
    $state,
    $location,
    LoginService,
    $scope,
    $mdToast,
    $timeout,
    PermRoleStore
  ) {
    Object.assign(this, {
      LoginService,
      $state,
      $location,
      $scope,
      $mdToast,
      $timeout,
      PermRoleStore
    });
    this.btnEnabled = false;

    if ([8080].includes(parseInt($window.location.port, 10))) {
      this.user = {
        email: 'mariano@codexia.io',
        password: 'abc123'
      };
      this.btnEnabled = true;
    }

    this.opts = {
      rememberMe: true
    };
  }

  doLogin() {
    this.btnEnabled = false;
    this.showSpin = true;
    this.LoginService.login(this.opts, this.user).then(
      data => {
        this.showSpin = false;
        // TODO: move to login service
        this.PermRoleStore.defineManyRoles(getRolesDefinition(data.user));
        this.$location.url('/');
      },
      () => {
        this.showSpin = false;
        this.btnEnabled = true;
        this.$mdToast.show(
          this.$mdToast
            .simple()
            .content('El email o la contraseña son inválidos')
            .position('top left')
            .hideDelay(3000)
            .parent('login')
            .toastClass('error')
        );
      }
    );
  }

  updateFormStatus() {
    if (this.user.email && this.user.password) {
      this.btnEnabled = true;
    } else {
      this.btnEnabled = false;
    }
  }
}

export default LoginController;
